<dynamic-form [apiName]="apiName"
              [label]="label"
              [group]="formGroup"
              [areaName]="areaName"
              [model]="model"
              [columns]="columns"
              [noSubmit]="deactivateSave"
              (cancelChange)="cancel()"
              (submitChange)="save()">
  <div class="content" *ngIf="formGroup">
    <ssg-select name="Categories"
                [multiple]="true"
                [group]="formGroup"
                [label]="'ClientApp.FrontOffice.Catalog.Description.Categories' | translate"
                apiName="ItemCategory/ReadLookUp"
                textFieldName="Title"
                valueFieldName="Id"
                (valueChange)="valueChange()"
                userClass="select-md">
    </ssg-select>
    <ssg-select name="Items"
                [multiple]="true"
                [group]="formGroup"
                [label]="'ClientApp.FrontOffice.Catalog.Description.Items' | translate"
                [dataList]="ItemWithCategory"
                textFieldName="Title"
                valueFieldName="Id"
                (valueChange)="valueChange()"
                userClass="select-md">
    </ssg-select>
    <ssg-select name="IgnoredItems"
                [multiple]="true"
                [group]="formGroup"
                [label]="'ClientApp.FrontOffice.Catalog.Description.IgnoredItems' | translate"
                [dataList]="IgnoredItemsWithCategory"
                textFieldName="Title"
                valueFieldName="Id"
                userClass="select-md"
                (valueChange)="valueChange()">
    </ssg-select>
  </div>
</dynamic-form>
